"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TIMER_OFFSET = exports.Storybook = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _reactJss = require("react-jss");
var _Snackbar = require("./Snackbar.styles");
var _FlatButton = _interopRequireDefault(require("../../components/FlatButton"));
var _PortalBase = _interopRequireDefault(require("../../components/PortalBase"));
var _NestedThemeProvider = _interopRequireDefault(require("../../ThemeProvider/NestedThemeProvider"));
var _Theme = require("../../themes/Theme");
var _defaultProps = _interopRequireDefault(require("../../utils/defaultProps"));
var _environmentCharacteristics = require("../../utils/environmentCharacteristics");
var _splitCommonFromProps8 = _interopRequireDefault(require("../../utils/splitCommonFromProps"));
var _excluded = ["action", "alignTop", "autoHideDuration", "cleanup", "className", "container", "justify", "message", "overrides", "open", "onClose", "children"],
  _excluded2 = ["children"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } /* eslint-disable jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events */ /**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var TIMER_OFFSET = exports.TIMER_OFFSET = 100;
var isISnackbarButtonProps = function isISnackbarButtonProps(value) {
  return "label" in value;
};
var Snackbar = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var _splitCommonFromProps = (0, _splitCommonFromProps8.default)(props, _Snackbar.snackbarCommon),
    _splitCommonFromProps2 = _slicedToArray(_splitCommonFromProps, 2),
    common = _splitCommonFromProps2[0],
    _splitCommonFromProps3 = _splitCommonFromProps2[1],
    action = _splitCommonFromProps3.action,
    alignTop = _splitCommonFromProps3.alignTop,
    _splitCommonFromProps4 = _splitCommonFromProps3.autoHideDuration,
    autoHideDuration = _splitCommonFromProps4 === void 0 ? 4000 : _splitCommonFromProps4,
    cleanup = _splitCommonFromProps3.cleanup,
    className = _splitCommonFromProps3.className,
    _splitCommonFromProps5 = _splitCommonFromProps3.container,
    container = _splitCommonFromProps5 === void 0 ? _environmentCharacteristics.isBrowser ? document.body : undefined : _splitCommonFromProps5,
    justify = _splitCommonFromProps3.justify,
    message = _splitCommonFromProps3.message,
    _splitCommonFromProps6 = _splitCommonFromProps3.overrides,
    overrides = _splitCommonFromProps6 === void 0 ? {} : _splitCommonFromProps6,
    _splitCommonFromProps7 = _splitCommonFromProps3.open,
    open = _splitCommonFromProps7 === void 0 ? false : _splitCommonFromProps7,
    onClose = _splitCommonFromProps3.onClose,
    children = _splitCommonFromProps3.children,
    otherProps = _objectWithoutProperties(_splitCommonFromProps3, _excluded);
  var timer = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isVisible = _useState2[0],
    setVisible = _useState2[1];
  var _useState3 = (0, _react.useState)(function () {
      return !open ? true : false;
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    isExiting = _useState4[0],
    setExiting = _useState4[1];
  var classes = (0, _Snackbar.useSnackbarStyles)(_objectSpread({
    snackbarHorizontal: justify ? 0 : "-50%",
    snackbarVertical: open && isVisible ? 0 : alignTop ? "-100%" : "100%"
  }, common));
  var rootClasses = (0, _classnames.default)(classes.variables, classes.root, classes[justify], classes[alignTop ? "top" : "bottom"], _defineProperty(_defineProperty(_defineProperty({}, classes.center, !justify), classes.rootOpen, open && isVisible), classes.rootClosed, !open || !isVisible), overrides.root, className);
  var handleTransition = function handleTransition() {
    if (!open) {
      setExiting(true);
      setVisible(false);
    }
    if (!open && isExiting && cleanup) {
      cleanup();
    }
  };
  (0, _react.useEffect)(function () {
    if (open) {
      setTimeout(function () {
        return setVisible(true);
      }, TIMER_OFFSET);
      if (autoHideDuration && onClose) {
        timer.current = setTimeout(onClose, autoHideDuration + TIMER_OFFSET);
      }
    }
    return function () {
      return clearTimeout(timer.current);
    };
  }, [autoHideDuration, onClose, open]);
  if (!isVisible && isExiting && !open) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement(_PortalBase.default, {
    container: container
  }, /*#__PURE__*/_react.default.createElement("span", _extends({
    ref: ref,
    className: rootClasses
  }, otherProps, {
    onTransitionEnd: handleTransition,
    onClick: onClose
  }), children ? /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(classes.children)
  }, children) : /*#__PURE__*/_react.default.createElement("p", {
    className: (0, _classnames.default)(classes.message, overrides.message)
  }, message), action && /*#__PURE__*/(0, _react.isValidElement)(action) && action, action && isISnackbarButtonProps(action) && /*#__PURE__*/_react.default.createElement(_FlatButton.default, _extends({
    className: classes.button,
    primary: true
  }, action))));
});
Snackbar.displayName = "Snackbar";
var SnackbarWrapper = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded2);
  var theme = (0, _reactJss.useTheme)();
  var staticTheme = [_Theme.PlatformId.streamfans, _Theme.PlatformId.kwiky, _Theme.PlatformId.streamate].includes(theme.themeProviderProps.platformId);
  return /*#__PURE__*/_react.default.createElement(_NestedThemeProvider.default, {
    themeMode: theme.mode,
    invertTheme: !staticTheme
  }, /*#__PURE__*/_react.default.createElement(Snackbar, _extends({
    ref: ref
  }, props), children));
});
var Storybook = exports.Storybook = SnackbarWrapper;

/**
 * @see https://icfreactcomponents.integ.icfsys.com/?path=/docs/feedback-snackbar--docs
 */
SnackbarWrapper.displayName = "Snackbar";
var exportedComponent = (0, _defaultProps.default)(SnackbarWrapper);
exportedComponent.displayName = "Snackbar";
var _default = exports.default = exportedComponent;